import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {
    Paging,
    Search,
    IInfoBubble,
    Filters,
    CardCatalogueDataSource,
    Sorting,
    ICard,
    IQueryParams,
    GridComponent,
    InfoBubbleComponent,
    HeadingComponent,
    CardCatalogueComponent,
} from '@sirius/common';
import { CardOverviewCommerce, CardProductCommerce, ProductCategories } from 'commerce/models';
import { TrackingCommerceService, TrackingCommerceSnowplowService } from 'commerce/services';
import { Product } from '@urweb/snowtype';
import { ICardContent } from 'shared/models';
import { MarketplaceCategoriesComponent } from '../marketplace-categories/marketplace-categories.component';

@Component({
    selector: 'commerce-card-overview-commerce',
    templateUrl: './card-overview-commerce.component.html',
    styleUrls: ['./card-overview-commerce.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        GridComponent,
        InfoBubbleComponent,
        HeadingComponent,
        CardCatalogueComponent,
        MarketplaceCategoriesComponent,
    ],
})
export class CardOverviewCommerceComponent implements OnInit {
    private _trackingService = inject(TrackingCommerceService);
    private _trackingCommerceService = inject(TrackingCommerceSnowplowService);

    @Input()
    config?: CardOverviewCommerce;

    filters: Filters = <Filters>{};
    paging: Paging = <Paging>{};
    sorting?: Sorting;
    searchQuery: Search = <Search>{};
    dataSource: CardCatalogueDataSource = 'commerce';
    additionalQueryParams: IQueryParams[] = [];
    infoBubble: IInfoBubble | null = null;
    selectedCategory?: string;
    //Marketplace (name) header not to be translated
    marketplaceHeader = 'UR+ Marketplace';

    mappedContentCards?: ICardContent[];

    ngOnInit() {
        if (this.config) {
            this.filters = new Filters(this.config.result.filters);
            this.paging = new Paging(this.config.result.paging);
            this.searchQuery = new Search(this.config.result.searchQuery);

            if (this.config.result.additionalQueryParams) {
                this.additionalQueryParams = this.config.result.additionalQueryParams;
            }

            if (this.config.result.selectedCategory) {
                this.selectedCategory = this.config.result.selectedCategory;
            }

            if (this.config.infoBubbleComponent) {
                this.infoBubble = this.config.infoBubbleComponent;
            }

            if (this.config.result.sorting) {
                this.sorting = new Sorting(this.config.result.sorting);
            }

            if (this.config.result.ecommerceViewTrackingObject) {
                this._trackingService.trackEvent(this.config.result.ecommerceViewTrackingObject);
            }
        }

        const productCategories = this.config?.result.categories;
        if (productCategories && productCategories.length > 0) {
            this.mappedContentCards = this.mapContentCards(productCategories);
        }

        this.trackProductListViewSnowplow();
    }

    mapContentCards(productCategories: ProductCategories[]): ICardContent[] {
        return productCategories.map((category: ProductCategories) => {
            const cardContentObject: ICardContent = {
                cardType: 'card-content',
                title: category.name,
                link: category.redirectLink,
                image: category.image,
                container: 'slider',
                dataSource: 'commerce',
            };

            return cardContentObject;
        });
    }

    private trackProductListViewSnowplow() {
        const products: Product[] = [];
        this.config?.result.items.forEach((item: ICard) => {
            const newItem = item as CardProductCommerce;
            const productSnowplow: Product = {
                id: newItem.productId,
                name: newItem.title,
                brand: newItem.manufacturer ?? '',
                creative_id: newItem.image.image.url,
                compatibility: newItem.compatibility ?? [],
                category: newItem.category ?? '',
                product_type: newItem.product_type ?? [],
                application_type: newItem.application_type ?? [],
                position: newItem.position,
            };
            products.push(productSnowplow);
        });

        this._trackingCommerceService.trackProductListView({
            products: products,
        });
    }
}
